<template>
  <div id="toolbar" class="row align-items-center justify-content-between" >
    <div class="col-sm-12 col-md-8">
      <span id="toolbar-list-all">
        <fontAwesomeIcon @click="listAllBatches" :icon="['fa', 'clipboard-list']" size="2x" class="showhand mx-2 align-middle"/>
      </span>
      <b-popover target="toolbar-list-all" triggers="hover" placement="bottomleft">
        <template v-slot:title>{{t('batchesToolbarListAll','batchesToolbarListAll')}}</template>
        {{t('batchesToolbarListAllDesc','batchesToolbarListAllDesc')}}
      </b-popover>
      <span id="toolbar-expand-all">
        <fontAwesomeIcon @click="expandAllBatches" :icon="['fa', 'layer-group']" size="2x" class="showhand mx-2 align-middle"/>
      </span>
      <b-popover target="toolbar-expand-all" triggers="hover" placement="bottomleft">
        <template v-slot:title>{{t('batchesToolbarExpandAll','batchesToolbarExpandAll')}}</template>
        {{t('batchesToolbarExpandAllDesc','batchesToolbarExpandAllDesc')}}
      </b-popover>
      <!-- EIPP-201 Added icon to refresh batches -->
      <span id="toolbar-refresh-all">
        <fontAwesomeIcon @click="refreshBatches" :icon="['fa', 'retweet']" size="2x" class="showhand mx-2 align-middle"/>
      </span>
      <b-popover target="toolbar-refresh-all" triggers="hover" placement="bottomleft">
        <template v-slot:title>{{t('batchesToolbarRefreshData','batchesToolbarRefreshData')}}</template>
        {{t('batchesToolbarRefreshDesc','batchesToolbarRefreshDesc')}}
      </b-popover>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolBar',
  methods: {
    listAllBatches() {
      this.$emit('list-all-batches')
    },
    expandAllBatches() {
      this.$emit('expand-all-batches')
    },
    refreshBatches() {
      this.$emit('refresh-all-batches')
    }
  }
}
</script>

<style scoped>
  .showhand{
    cursor: pointer;
  }
</style>
